import React, { FC } from 'react';
import { useTranslate } from '@/translations';
import { PageContainer, Title, faLocationDot } from '@/ui/components';
import { Card } from 'antd';
import { LocationsDataGrid } from './components/LocationsDataGrid/LocationsDataGrid';

export const AdminLocations: FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('manageLocations')} icon={faLocationDot} />

      <Card>
        <LocationsDataGrid />
      </Card>
    </PageContainer>
  );
};
